import { siteInfo } from '@/mocks/home';

export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/50"></div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 w-full">
          <div className="flex-1 w-full flex flex-col items-start gap-5 md:gap-6">
            <div className="flex flex-wrap gap-2">
              <span className="inline-flex items-center px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                韩漫
              </span>
              <span className="inline-flex items-center px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                日漫
              </span>
              <span className="inline-flex items-center px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-800 whitespace-nowrap">
                国漫
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight">
              丫丫漫画 · 韩漫日漫国漫热门分类大全
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading">
              {siteInfo.slogan}
            </p>

            <div className="space-y-3">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-xl">
                {siteInfo.description}
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
                {siteInfo.description2}
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-4 md:gap-6">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="flex items-baseline gap-1.5">
                  <span className="text-xl md:text-2xl font-bold text-primary-500">{stat.value}</span>
                  <span className="text-xs md:text-sm text-foreground-600">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
              <a
                href="#cards"
                onClick={(e) => handleScrollTo(e, '#cards')}
                className="inline-flex items-center justify-center px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                开始阅读 <i className="ri-arrow-right-line ml-1.5"></i>
              </a>
              <a
                href="#index"
                onClick={(e) => handleScrollTo(e, '#index')}
                className="inline-flex items-center justify-center px-6 py-3 bg-background-50 border border-background-300 text-foreground-800 font-medium rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                浏览分类 <i className="ri-grid-line ml-1.5"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20comic%20book%20and%20manga%20collage%20with%20dynamic%20characters%20from%20Korean%20manhwa%20Japanese%20manga%20and%20Chinese%20manhua%2C%20warm%20coral%20and%20golden%20tones%2C%20energetic%20composition%2C%20clean%20cream%20background%2C%20modern%20illustration%20style%2C%20playful%20and%20exciting%20atmosphere%2C%20professional%20editorial%20quality&width=960&height=720&seq=hero-main-01&orientation=landscape"
                alt="丫丫漫画 - 韩漫日漫国漫热门漫画合集展示"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/10 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}